<template>
    <div>
      <van-form ref="scoreForm" :disabled="active!=='todo'">
        <h1 v-if="vetoContent.length" class="card-title">评审信息</h1>
        <cell v-if="vetoContent.length" title="否决项"></cell>
        <checkbox-group v-model="vetoResult" ref="checkboxGroup">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in vetoContent"
              clickable
              :key="item"
              :title="item[getVetoKey('主要检查内容')]"
              @click="toggle(index)"
            >
              <template #right-icon>
                <checkbox shape="square" :disabled="active!=='todo'" :name="item" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </checkbox-group>
        
        <div class="van-cell" style="flex-flow: column;" v-for="(item, index) in scoreContent">
          <div style="display: flex;">
            <div class="van-cell__title">{{ item[getScoreKey('主要检查内容')] }}</div>
            <div>{{ item[getScoreKey('考核评分')] }}分</div>
          </div>
          <div style="display: flex;margin-top: 0.4rem;">
            <div v-if="!hideOpt" style="flex: 1;margin-right: 1rem;">
              <van-field
                v-model="item[getScoreKey('评分说明')]"
                rows="1"
                autosize
                type="textarea"
                :disabled="active!=='todo'"
                placeholder="请输评分说明"
              />
            </div>
            <div :style="hideOpt ? { flex: 1 } : {width: '11rem'}">
              <van-field v-model="item[getScoreKey('评分')]" :disabled="active!=='todo'" :rules="[{ required: vetoResult.length==0 && item[getScoreKey('考核评分')] }]" format-trigger="onBlur" :formatter="(res) => { return formatter(res, item[getScoreKey('考核评分')]) }" placeholder="请输入评分" type="digit" input-align="right" />
            </div>
          </div>
        </div>
        
        <template v-if="scoreContent.length">
          <h1 class="card-title">评审信息</h1>
          <cell title="审核总分" :value="scoreTotal"></cell>
          <cell title="审核结果" :value="soreResult"></cell>
        </template>
      </van-form>
    </div>
</template>

<script>
import { Form, Cell, CellGroup, Checkbox, CheckboxGroup } from 'vant';
import application from '@api/application';
export default {
    name:'scoreForm',
    components: {
      CheckboxGroup,
      Checkbox,
      CellGroup,
      Form,
      Cell
    },
    props: {
      formData: {
        type: Object,
        default() {
          return {}
        }
      },
      hideOpt: {
        type: Boolean,
        default() {
          return false
        }
      },
      businessId: {
        type: String,
        default() {
            return ''
        }
      },
      subLoading: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
        return {
          opinions: '',
          digit: '',
          list: ['a', 'b'],
          vetoHeaderId: '',
          vetoHeader: [],
          vetoContent: [],
          scoreHeader: [],
          scoreContent: [],
          vetoResult: [],
          scoreItems: [],
          scoreForm: {
            id: '',
            vetoList: [],
            contentList: [],
            opinion: '',
            totalScore: '',
            result: '',
          }
        }
    },
    created(){
      // this.getDetail()
    },
    computed: {
      scoreData() {
        return this.formData
      },
      scoreTotal() {
        let num = 0;
        this.scoreContent.forEach((item) => {
          let count = item[this.getScoreKey('评分')]
          if (count && !isNaN(Number(count))) {
            num += Number(count)
          }
        })
        return 100 - num
      },
      soreResult() {
        if(this.vetoList.length > 0) {
          return '不合格'
        }
        if(this.scoreTotal< 70){
          return  "不合格"
        }else if(this.scoreTotal>=70 && this.scoreTotal<80){
          return  "合格"
        }else if(this.scoreTotal>=80 && this.scoreTotal<90){
          return  "良好"
        }else if(this.scoreTotal>=90){
          return  "优秀"
        } else {
          return ''
        }
      },
      vetoList() {
        let res = []
        this.vetoResult.forEach((item) => {
          let obj = {}
          obj[this.vetoHeaderId] = '是'
          obj['id'] = item.id
          res.push(obj)
        })
        return res
      },
      contentList() {
        let res = []
        this.scoreContent.forEach((item) => {
          let obj = {}
          let scoreKey = this.getScoreKey('评分')
          let optinKey = this.getScoreKey('评分说明')
          if (item[optinKey]) { obj[optinKey] = item[optinKey] }
          if (item[scoreKey]) { obj[scoreKey] = item[scoreKey] }
          obj['id'] = item.id
          res.push(obj)
        })
        return res
      },
      id () {
        return this.businessId
      },
      active() {
        return this.$route.query.active
      },
      userInfo() {
        return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
      },
    },
    methods: {
      getDetail() {
        // console.log(this.scoreData)
        this.vetoHeader = this.scoreData.vetoHeader || []
        this.vetoContent = this.scoreData.vetoContent || []
        this.vetoHeaderId = this.getVetoKey('是否否决')
        
        // 源数据默认选中项
        let checked = (this.vetoContent && this.vetoContent.length > 0) ? this.vetoContent.filter((item) => item[this.getVetoKey('是否否决')]) : []
        // 默认选中
        this.vetoResult = checked
        
        this.scoreHeader = this.scoreData.scoreHeader || []
        this.scoreContent = JSON.parse(JSON.stringify((this.scoreData.scoreContent))) || []
      },
      getVetoKey (title) {
        if (!this.vetoHeader) return ''
        let keys = this.vetoHeader.filter((item) => item.title == title)
        return keys.length > 0 ? keys[0].dataIndex : ''
      },
      getScoreKey (title) {
        if (!this.scoreHeader) return ''
        let keys = this.scoreHeader.filter((item) => item.title == title)
        return keys.length > 0 ? keys[0].dataIndex : ''
      },
      formatter(value, max) {
        if (!value || !max) return ''
        return Number(value) > Number(max) ? Number(max) : Number(value)
      },
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
      },
      getFormData() {
        return {
          vetoList: this.vetoList,
          contentList: this.contentList,
          totalScore: this.scoreTotal,
          result: this.soreResult
        }
      },
      formValidate() {
        return this.$refs.scoreForm.validate()
      },
      // sub() {
      //   return new Promise(this.approval)
      // },
      // approval(resolve, reject) {
      //   const subForm = {
      //     id: this.id,      //     vetoList: this.vetoList,      //     contentList: this.contentList,      //     // opinion: this.scoreForm.opinion,      //     // totalScore: this.scoreTotal,      //     // result: this.soreResult,
      //   }
      //   console.log(subForm)
      //   let flag = (this.scoreTotal < 80 || this.vetoList.length > 0)
      //   application.submitScoreForm(subForm).then((res) => {
      //     if (res && res.code == '200') {
      //       resolve(flag)
      //       // this.$emit('onSub', flag)
      //     } else {
      //       reject()
      //       // this.$emit('closeSubLoading', 'scoreBtn')
      //     }
      //   }).catch((err) => {
      //     reject()
      //   })
      // }
    },
    mounted() {
    },
    watch: {
      formData: {
        handler:function(val,oldval){
          this.getDetail()
        },
        deep:true
      }
    }
}
</script>

<style lang="scss" scoped>
.card-title {
  font-size: 1.6rem;
  font-weight: normal;
  padding: 1rem 1.6rem;
  color: #999;
  background: #f7f8fa;
}
.btns {
  overflow: hidden;
  // display: flex;
  // justify-content: space-between;
  padding: 1rem 1.6rem;
  ::v-deep .van-button {
    border-radius: 0.4rem;
    float: right;
    margin-left: 1rem;
  }
}
.van-checkbox-group {
  ::v-deep .van-cell__title {
    margin-left: 1.6rem;
  }
}
::v-deep .van-field {
  background: #F2F2F2;
  border-radius: 0.4rem;
}
::v-deep .van-field.van-field--error {
  background: #FFF9E8;
}

</style>
